import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import delle traduzioni
import enCheckIn from "./locales/en/checkIn.json";
import enCommon from "./locales/en/common.json";
import enGuestForm from "./locales/en/guestForm.json";
import enSurvey from "./locales/en/survey.json";
import enCart from "./locales/en/cart.json";
import enCheckout from "./locales/en/checkout.json";
import enPreventiveRequest from "./locales/en/preventiveRequest.json";
import itCheckIn from "./locales/it/checkIn.json";
import itCommon from "./locales/it/common.json";
import itGuestForm from "./locales/it/guestForm.json";
import itSurvey from "./locales/it/survey.json";
import itCart from "./locales/it/cart.json";
import itCheckout from "./locales/it/checkout.json";
import itPreventiveRequest from "./locales/it/preventiveRequest.json";
import itHotelInfo from "./locales/it/hotelInfo.json";
import enHotelInfo from "./locales/en/hotelInfo.json";

// Risorse per le lingue
const resources = {
  it: {
    common: itCommon,
    checkIn: itCheckIn,
    guestForm: itGuestForm,
    survey: itSurvey,
    hotelInfo: itHotelInfo,
    cart: itCart,
    checkout: itCheckout,
    preventiveRequest: itPreventiveRequest,
  },
  en: {
    common: enCommon,
    checkIn: enCheckIn,
    guestForm: enGuestForm,
    survey: enSurvey,
    hotelInfo: enHotelInfo,
    cart: enCart,
    checkout: enCheckout,
    preventiveRequest: enPreventiveRequest,
  },
};

const normalizeLanguage = (lng?: string) => {
  if (!lng) return "it";

  const normalizedLng = lng.toLowerCase();
  if (normalizedLng.startsWith("it")) return "it";
  if (normalizedLng.startsWith("en")) return "en";

  return normalizedLng.split("-")[0];
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Fallback language
    fallbackLng: "it",
    supportedLngs: ["it", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    debug: false, // Set to true for development debugging

    // Namespace configuration
    defaultNS: "common",
    ns: [
      "common",
      "checkIn",
      "guestForm",
      "survey",
      "hotelInfo",
      "cart",
      "checkout",
      "preventiveRequest",
    ],

    // Resources
    resources,

    // Language detection configuration
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: (lng?: string) => normalizeLanguage(lng),
    },

    // Interpolation
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // React options
    react: {
      useSuspense: false, // Disable suspense mode
    },
  });

export default i18n;
